import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { FormArray, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { EtxeEnumDisplayPipe } from '../../../pipes/etxe-enum-display.pipe';
import { PropertySpaceForm, PropertySpaceInCoOwnershipForm } from '../../../types/property-form.types';

@Component({
  selector: 'etxe-property-spaces-list',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    EtxeEnumDisplayPipe,
  ],
  templateUrl: './spaces-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PropertySpacesListComponent {
  title = input.required<string>();
  formArray = input.required<
    FormArray<FormGroup<PropertySpaceForm>> | FormArray<FormGroup<PropertySpaceInCoOwnershipForm>>
  >();
  itemLabel = input.required<string>(); // e.g., "Pièce", "Chambre"
  addButtonLabel = input<string>('Ajouter');

  // Type Select Configuration
  typeOptions = input<string[] | undefined>(undefined); // If provided, shows a select
  typeEnumLabel = input<string | undefined>(undefined); // For the pipe, e.g. 'room'

  // Customization
  descriptionPlaceholder = input<string>('Précision ou description');
  hint = input<string | undefined>(undefined);
  showLotNumber = input<boolean>(false);

  add = output<void>();
  remove = output<number>();

  get controls() {
    return this.formArray().controls;
  }
}
